import { useSiteCharacteristic } from 'api/saq/hooks/useSiteCharacteristic/useSiteCharacteristic';
import { ColumnInfo, RiskInfo, SiteCharacteristicType } from 'api/saq/types';
import { EditableScoresTable } from 'components/EditableScoresTable/EditableScoresTable';

const siteCharacteristicColumns = [
  { name: 'Pillar', property: 'pillar' },
  { name: 'Question', property: 'question' },
  { name: 'SAQ vs Worker info table', property: 'isSaq' }
] as ColumnInfo<SiteCharacteristicType>[];

export const SiteCharacteristic = () => {
  const { data, allScores, isLoading } = useSiteCharacteristic();

  return (
    <EditableScoresTable
      title="Risk: Site Characteristics - question scores"
      riskInfo={{ data, allScores, isLoading } as RiskInfo<SiteCharacteristicType>}
      columns={siteCharacteristicColumns}
    />
  );
};
